import { render, staticRenderFns } from "./DSDotsIcon.vue?vue&type=template&id=8ae5b150&scoped=true&"
import script from "./DSDotsIcon.vue?vue&type=script&lang=js&"
export * from "./DSDotsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae5b150",
  null
  
)

export default component.exports